import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

// Import components
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import ProfessorList from './components/professors/ProfessorList';
import ProfessorDetail from './components/professors/ProfessorDetail';
import SettingsPage from './pages/settings/SettingsPage';
import WaitlistPage from './pages/waitlist/WaitlistPage';
import ProfessorMetricsPage from './pages/professors/ProfessorMetricsPage';
import DiagPage from './pages/DiagPage';
import ProgramsPage from './pages/programs/ProgramsPage';

// Protected route component
const ProtectedRoute: React.FC<{ element: React.ReactElement }> = ({ element }) => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? element : <Navigate to="/login" />;
};

const AppContent: React.FC = () => {
  const { isLoggedIn } = useAuth();
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={!isLoggedIn ? <Login /> : <Navigate to="/dashboard" />} />
      <Route path="/signup" element={!isLoggedIn ? <Signup /> : <Navigate to="/dashboard" />} />
      <Route path="/waitlist" element={<WaitlistPage />} />
      <Route path="/programs" element={<ProgramsPage />} />
      <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
      <Route path="/professors" element={<ProfessorList />} />
      <Route path="/professor-metrics" element={<ProtectedRoute element={<ProfessorMetricsPage />} />} />
      <Route path="/professors/:id" element={<ProtectedRoute element={<ProfessorDetail />} />} />
      <Route path="/settings" element={<ProtectedRoute element={<SettingsPage />} />} />
      <Route path="/diag" element={<DiagPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

const AppWithLanding: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default AppWithLanding;
